import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import HelpIcon from '@material-ui/icons/Help';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SchoolIcon from '@material-ui/icons/School';
import SettingsIcon from '@material-ui/icons/Settings';
import PowerSettingsIcon from '@material-ui/icons/PowerSettingsNew';
import clsx from 'clsx';
import logo from '../../images/logo.png';
import { logOut } from '../../redux/actions';
import HelpModal from '../HelpModal';
import ReportError from '../ReportError';
import InfoModal from '../InfoModal';
import buildInfo from '../../config/buildInfo.json';
import { getBuildNo } from '../../tools';
import { showTestDialog } from '../../redux/actions';

const useStyles = makeStyles(theme => ({
  appBar: {
    display: 'block',
    '& svg': {
      color: '#bbb',
      transition: 'color 0.3s',
    },
    '& button:hover svg': {
      color: '#777',
    },
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  toolbar: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    width: 140,
    height: 'auto',
  },
  icon: {
    color: '#737373',
    width: '1.5em',
    height: '1.5em',
  },
  menu: {
    '& div': {
      minWidth: 40,
    },
  },
}));

const isDevelopment = process.env.NODE_ENV === 'development';

function TopMenu(props) {
  const classes = useStyles();
  const { auth } = props;
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [helpMenuAnchor, setHelpMenuAnchor] = useState(null);
  const [mainHelp, setMainHelp] = useState(false);
  const [adviseHelp, setAdviseHelp] = useState(false);
  const [reportError, setReportError] = useState(false);
  const [aboutHelp, setAboutHelp] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(false);
  const openUserMenu = Boolean(userMenuAnchor);
  const openHelpMenu = Boolean(helpMenuAnchor);
  const location = useLocation();
  const showMenu = auth.loggedIn && location.pathname !== '/login';

  const handleUserMenu = (event) => {
    setUserMenuAnchor(event.currentTarget);
  };

  const handleHelpMenu = (event) => {
    setHelpMenuAnchor(event.currentTarget);
  };

  const closeUserMenu = () => {
    setUserMenuAnchor(null);
  };

  const closeHelpMenu = () => {
    setHelpMenuAnchor(null);
  };

  const logOut = () => {
    props.logOut();
    closeUserMenu();
  }

  const mainHelpToggle = () => {
    setMainHelp(!mainHelp);
    closeHelpMenu();
  }

  const adviseHelpToggle = () => {
    setAdviseHelp(!adviseHelp);
    closeHelpMenu();
  }

  const reportErrorToggle = () => {
    setReportError(!reportError);
    closeHelpMenu();
  }

  const aboutToggle = () => {
    setAboutHelp(!aboutHelp);
    closeHelpMenu();
  }

  const aboutData = () => {
    const system = auth.browser.system;
    let currentInfo;
    getBuildNo()
      .then((ver) => {
        if (currentVersion !== ver) setCurrentVersion(ver);
      }).catch(e => console.log(e));
    if (currentVersion === false) {
      currentInfo = '';
    } else {
      currentInfo = buildInfo.build === currentVersion ? '(aktualna)' : `(${currentVersion})`;
    }

    let content = `<div style="text-align: center;">
      <h3>Platforma Edukacyjna Szybki Angielski</h3>`;

    content += `
      <p style="color: #001eb1">ostatnia aktualizacja: ${buildInfo.date}<br/>numer kompilacji: ${buildInfo.build} ${currentInfo}<br />
      ${system.os.name} ${system.os.version}<br />
      ${system.browser.name} ${system.browser.version}<br />
      browser status: ${auth.browser.status}</p>
      <p><small>Copyright Instytut Colina Rose Sp. z o.o. Wszelkie prawa zastrzeżone</small><br />
      <small style="color: #999">devs: Grzegorz Sarzyński & Michał Juński</small>
      </p>
      </div>
    `;

    return { title: 'O programie', content }
  }

  const testDialog = () => {
    props.showTestDialog();
    closeUserMenu();
  }

  if (!showMenu) return '';

  return (
    <>
      <AppBar elevation={1} position="static" color="default" className={classes.appBar}>

        <Toolbar className={clsx('container', classes.toolbar)}>
          <Link to="/">
            <img src={logo} className={classes.logo} alt="" />
          </Link>
          <div>

            <IconButton onClick={handleHelpMenu} color="inherit">
              <HelpIcon className={classes.icon} />
            </IconButton>

            <IconButton onClick={handleUserMenu} color="inherit">
              <AccountCircle className={classes.icon} />
            </IconButton>

            <Menu
              id="user-menu"
              anchorEl={userMenuAnchor}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={openUserMenu}
              onClose={closeUserMenu}
              className={classes.menu}
            >
              <MenuItem onClick={closeUserMenu} component={Link} to="/kursy">
                <ListItemIcon><SchoolIcon /></ListItemIcon>
                <Typography>Kursy</Typography>
              </MenuItem>
              <MenuItem onClick={closeUserMenu} component={Link} to="/ustawienia">
                <ListItemIcon><SettingsIcon /></ListItemIcon>
                <Typography>Ustawienia</Typography>
              </MenuItem>
              {isDevelopment && <MenuItem onClick={testDialog}>
                <ListItemIcon><SettingsIcon /></ListItemIcon>
                <Typography>Test</Typography>
              </MenuItem>}
              <MenuItem onClick={logOut}>
                <ListItemIcon><PowerSettingsIcon /></ListItemIcon>
                <Typography>Wyloguj</Typography>
              </MenuItem>
            </Menu>

            <Menu
              id="help-menu"
              anchorEl={helpMenuAnchor}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={openHelpMenu}
              onClose={closeHelpMenu}
              className={classes.menu}
            >
              <MenuItem onClick={mainHelpToggle}>
                <Typography>Korzystanie z aplikacji</Typography>
              </MenuItem>
              <MenuItem onClick={adviseHelpToggle}>
                <Typography>Efektywna nauka</Typography>
              </MenuItem>
              <MenuItem onClick={reportErrorToggle}>
                <Typography>Zgłoś błąd</Typography>
              </MenuItem>
              <MenuItem onClick={aboutToggle}>
                <Typography>O programie</Typography>
              </MenuItem>
            </Menu>

          </div>
        </Toolbar>
      </AppBar>
      {mainHelp && <HelpModal close={mainHelpToggle} options={{ name: 'main', option: 'tabs' }} />}
      {adviseHelp && <HelpModal close={adviseHelpToggle} options={{ name: 'jak-sie-uczyc-efektywnie', option: 'tabs' }} />}
      {aboutHelp && <InfoModal close={aboutToggle} data={aboutData()} />}
      {reportError && <ReportError close={reportErrorToggle} />}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isMobile: state.mobile,
  }
}

export default connect(mapStateToProps, {
  logOut,
  showTestDialog,
})(TopMenu)
